import React, { Component } from "react";

const HygieneIcon = ({ width, height, fill, ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      {...rest}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.94922 9.375H12.0508V6.73828H14.6875V2.63672H12.0508V0H7.94922V2.63672H5.3125V6.73828H7.94922V9.375ZM6.48438 5.56641V3.80859H9.12109V1.17188H10.8789V3.80859H13.5156V5.56641H10.8789V8.20312H9.12109V5.56641H6.48438Z"
        fill={fill}
      />
      <path
        d="M0 20H20L18.1689 16.4843H17.4502L20 11.5888V3.51562C20 2.54637 19.2114 1.75781 18.2422 1.75781C17.2729 1.75781 16.4843 2.54637 16.4843 3.51562V7.99139C15.8659 7.77382 15.1491 7.91175 14.6555 8.40546L10.2705 12.7904C10.1722 12.8887 10.0822 12.9931 9.99998 13.1022C9.91771 12.9931 9.82768 12.8887 9.72939 12.7904L5.34452 8.40546C4.85081 7.91178 4.13409 7.77382 3.51562 7.99139V3.51562C3.51562 2.54637 2.72706 1.75781 1.75781 1.75781C0.788553 1.75781 0 2.5464 0 3.51562V11.5887L2.5498 16.4843H1.83105L0 20ZM18.0684 18.8281H10.5859V17.6562H17.458L18.0684 18.8281ZM11.0992 13.619L15.4841 9.23413C15.7126 9.00569 16.0843 9.00569 16.3127 9.23413C16.4234 9.34479 16.4844 9.49194 16.4844 9.64846C16.4844 9.80498 16.4234 9.95209 16.3127 10.0628L11.9295 14.4459L12.7582 15.2745L17.1413 10.8914C17.4688 10.564 17.6507 10.1302 17.6557 9.66795C17.6562 9.66795 17.6562 3.51562 17.6562 3.51562C17.6562 3.19254 17.9191 2.92969 18.2422 2.92969C18.5652 2.92969 18.8281 3.19254 18.8281 3.51562V11.3019L16.1289 16.4843H10.5859V14.8633C10.5859 14.392 10.7682 13.9501 11.0992 13.619ZM1.17187 11.3019V3.51562C1.17187 3.19254 1.43472 2.92969 1.75781 2.92969C2.08089 2.92969 2.34375 3.19254 2.34375 3.51562V9.66795C2.34992 10.1115 2.52089 10.5537 2.85859 10.8914L7.24178 15.2745L8.07041 14.4459L3.68726 10.0628C3.45878 9.83428 3.45878 9.46256 3.68726 9.23413C3.91577 9.00569 4.28749 9.00565 4.51593 9.23413L8.90076 13.619C9.23174 13.9501 9.41404 14.392 9.41404 14.8633V16.4843H3.87109L1.17187 11.3019ZM2.54199 17.6562H9.41404V18.8281H1.93164L2.54199 17.6562Z"
        fill={fill}
      />
    </svg>
  );
};

HygieneIcon.defaultProps = {
  width: 20,
  height: 20,
  fill: "black",
};

export default HygieneIcon;
